export default __webpack_public_path__ + "static/media/ip3X.a61d877f.svg";